import { render } from "./SubmenuContext.vue?vue&type=template&id=5600418a"
import script from "./SubmenuContext.vue?vue&type=script&lang=js"
export * from "./SubmenuContext.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__